<template>
  <CanadaTwoEight/>
</template>

<script>
import CanadaTwoEight from './components/CanadaTwoEight.vue'

export default {
  name: 'App',
  components: {
    CanadaTwoEight
  },
  data() {
    return {
      isRouterAlive: true
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
</style>
